var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72399 6.293C9.72399 6.293 10.47 1.905 7.42599 0C7.38064 0.753945 7.17675 1.48984 6.82765 2.15963C6.47854 2.82941 5.99206 3.41802 5.39999 3.887C4.09999 5.03 1.65499 7.6 1.68099 10.34C1.67165 11.5113 1.98982 12.6619 2.59959 13.662C3.20936 14.6621 4.08648 15.4719 5.13199 16C5.16934 15.4711 5.31188 14.955 5.55125 14.482C5.79062 14.0089 6.12201 13.5884 6.52599 13.245C6.86832 12.9817 7.1548 12.6529 7.36872 12.2778C7.58265 11.9027 7.71974 11.4887 7.77199 11.06C8.66692 11.5358 9.42306 12.2356 9.96644 13.0912C10.5098 13.9468 10.8218 14.9287 10.872 15.941V15.954C11.8588 15.502 12.7013 14.7858 13.3063 13.8846C13.9113 12.9835 14.2552 11.9325 14.3 10.848C14.516 8.274 13.106 4.774 11.855 3.63C11.3827 4.68445 10.6492 5.601 9.72399 6.293Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.65f2056f.svg";
export { ForwardRef as ReactComponent };